import React from 'react';
import { GeneralSettings } from './Api';

let defaultSettings: GeneralSettings = {
    textInputLimit: 100,
    emailInputLimit: 512,
    applicationPermittedExtensions: ['.jpeg', '.jpg', '.png', '.pdf', '.docx'],
    applicationPermittedMimeTypes: ['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    applicationFileNumberLimit: 10,
    applicationFileSizeLimit: 15728640,
    applicationPhoneNumberRegex: "/^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{2,4})(?:[-.x ]*(\d+))?)\s*$/gm",
    isUnicode: false,
    imagesUrl: "",
};

const state = {
    isLoading: true,
    settings: defaultSettings,
}

const SettingsContext = React.createContext(state);

export default SettingsContext;